// Service worker opt-out. Stock CRA template originally also exposed
// `register()` (cache-first PWA mode) plus its `registerValidSW` /
// `checkValidServiceWorker` helpers; those were removed because no caller
// uses them. If offline/PWA behaviour is later needed, restore from git
// history (`git log -- src/serviceWorker.js`) or from a fresh CRA template.

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
